export default __webpack_public_path__ + "static/media/navbar-rules-dark.ac94ed09.svg";